import { Component, ViewEncapsulation, ViewChild, Input, AfterViewInit } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';
import { GItem } from '@app/cp/shared/models/GItem';
import { BaseEditComponent } from '@app/cp/shared/base-components/base-edit.component';
import { OrderService } from '@app/cp/shared/services/order.service';
import { VendorReturnBus } from '@app/cp/shared/models/VendorReturnBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { GeographyInfoBus } from '@app/cp/shared/models/GeographyInfoBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { VendorReturnPartsComponent } from './vendor-return-parts/vendor-return-parts.component';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { OrderDetailsBus } from '@app/cp/shared/models/OrderDetailsBus';
import { VendorReturnDetailBus } from '@app/cp/shared/models/VendorReturnDetailBus';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { CPDialogResult } from '@app/cp/shared/enums/CPDialogResult';
import { CRUDActions } from '@app/cp/shared/enums/CRUDActions';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'vendor-returns',
    templateUrl: './vendor-returns.component.html',
    styleUrls: ['./vendor-returns.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VendorReturnsComponent extends BaseEditComponent<VendorReturnBus, OrderService, null, null> implements AfterViewInit  {
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: OrderService, private svc_inventory: InventoryService) {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.setParam();
        this.readOnly = false;
        this.saveMode = SaveMode.all;
    }
    @ViewChild("LineItems") lineItemsComponent: VendorReturnPartsComponent;

    public setup(data: any) { }

    @Input() inputSupplier: any;
    @Input() inputLocation: any;
    @Input() defaultInventory: OrderDetailsBus[] = [];
    @Input() orderNumber: string = "";

    appCode: string = "Vendor Return";

    ngAfterViewInit() {
        if (this.inputSupplier && CommonFunctions.hasGuidValue(this.inputSupplier)) {
            this.patchFormSupplier(this.inputSupplier);
            if (this.inputLocation && CommonFunctions.hasGuidValue(this.inputLocation)) {
                this.patchFormSupplierLocation(this.inputLocation);
                this.supplierLocationChanged(this.inputLocation);
            }
        }
        let today = new Date();
        this.patchFormDate(today);
    }

    defaultRows: VendorReturnDetailBus[] = [];
    setDefaultInv() {
        if (this.defaultInventory && CommonFunctions.hasArrayValue(this.defaultInventory)) {
            this.defaultRows = [];
            this.defaultInventory.forEach(detail => {
                let item: VendorReturnDetailBus = new VendorReturnDetailBus();
                item.vendorReturnDetailId = CommonFunctions.getGuid(),
                item.orderId = detail.orderId;
                item.dispatchId = detail.dispatchId;
                item.qtyToReturn = detail.quantity;
                item.inventoryId = detail.inventoryId;
                item.isWarranty = false;
                item.returnNote = "";
                item.isAdded = true;
                item.insertUserId = this.globals.userId;
                item.insertDt = new Date();
                item.updateUserId = this.globals.userId;
                item.updateDt = new Date();
                item.number = detail.inventoryNumber;
                item.inventoryDesc = detail.inventoryDesc;
                item.dispatchNumber = detail.dispatchNumber;
                item.orderNumber = detail.inventoryId ? this.orderNumber : null;
                item.inventoryLocationId = detail.inventoryLocationId;
                this.defaultRows.push(item);
            });
            this.lineItemsComponent.gridData = this.defaultRows;
        }
    }

    setFormDefaults() {
        if (this.inputSupplier && CommonFunctions.hasGuidValue(this.inputSupplier)) {
            this.patchFormSupplier(this.inputSupplier);
            if (this.inputLocation && CommonFunctions.hasGuidValue(this.inputLocation)) {
                this.patchFormSupplierLocation(this.inputLocation);
                this.supplierLocationChanged(this.inputLocation);
            }
        }
        let today = new Date();
        this.patchFormDate(today);
    }

    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'vendorReturnId': new UntypedFormControl(),
        'companyId': new UntypedFormControl(),
        'returnDate': new UntypedFormControl(),
        'supplierId': new UntypedFormControl(),
        'supplierLocationId': new UntypedFormControl(),
        'addressLine1': new UntypedFormControl(),
        'addressLine2': new UntypedFormControl(),
        'city': new UntypedFormControl(),
        'stateProvince': new UntypedFormControl(),
        'postalCode': new UntypedFormControl(),
        'returnTicketNumber': new UntypedFormControl(),
        'vendorReturnStatusId': new UntypedFormControl(),
        'returnNote': new UntypedFormControl(),
        'returnTrackNbr': new UntypedFormControl(),
        'returnVendTrackNbr': new UntypedFormControl(),
        'vendorCreditId': new UntypedFormControl(),
        'ignoreOpenStatus': new UntypedFormControl(),
        'creditLinkUserId': new UntypedFormControl(),
        'ignoreStatusTxt': new UntypedFormControl(),
        'creditLinkDt': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl(),
        'updateDt': new UntypedFormControl()
    });
    setForm() {
        this.editForm.patchValue({
            vendorReturnId: this.data.vendorReturnId,
            companyId: this.data.companyId,
            returnDate: this.data.returnDate,
            supplierId: this.data.supplierId,
            supplierLocationId: this.data.supplierLocationId,
            addressLine1: this.data.addressLine1,
            addressLine2: this.data.addressLine2,
            city: this.data.city,
            stateProvince: this.data.stateProvince,
            postalCode: this.data.postalCode,
            returnTicketNumber: this.data.returnTicketNumber,
            vendorReturnStatusId: this.data.vendorReturnStatusId,
            returnNote: this.data.returnNote,
            returnTrackNbr: this.data.returnTrackNbr,
            returnVendTrackNbr: this.data.returnVendTrackNbr,
            vendorCreditId: this.data.vendorCreditId,
            ignoreOpenStatus: this.data.ignoreOpenStatus,
            creditLinkUserId: this.data.creditLinkUserId,
            insertUserId: this.data.insertUserId,
            insertDt: this.data.insertDt,
            updateUserId: this.data.updateUserId,
            updateDt: this.data.updateDt
        });
    }
    patchFormDate(date: Date) {
        this.editForm.patchValue({
            returnDate: date
        });
    }
    patchFormreturnTicketNumber(ticket: number) {
        this.editForm.patchValue({
            returnTicketNumber: ticket
        });
    }
    patchFormAddress(data: GeographyInfoBus) {
        this.editForm.patchValue({
            addressLine1: data.addressLine1,
            addressLine2: data.addressLine2,
            city: data.city,
            stateProvince: data.stateProvince,
            postalCode: data.postalCode
        });
    }
    patchFormSupplier(id: any) {
        this.editForm.patchValue({
            supplierId: id
        });
        this.supplierChanged(id, false);
    }
    patchFormSupplierLocation(id: any) {
        this.editForm.patchValue({
            supplierLocationId: id
        });
        this.supplierLocationChanged(id);
    }
    supplierLocations: GItem[];
    supplierCBOChanged(e: any) {
        this.supplierChanged(e.value);
    }
    supplierLocationCBOChanged(e: any) {
        this.supplierLocationChanged(e.value);
    }
    supplierChanged(id: any, holdGetAddress: boolean = false) {
        this.supplierLocations = this.referenceData.getSupplierLocations(id);
        if (!holdGetAddress) {
            this.svc_inventory.getSupplierAddress(id).subscribe(data => {
                this.patchFormAddress(data);
            });
        }
    }
    supplierLocationChanged(id: any) {
        this.svc_inventory.getSupplierLocationAddress(id).subscribe(data => {
            this.patchFormAddress(data);
        });
    }
    createNew(busObj: VendorReturnBus) {
        return new VendorReturnBus(busObj);
    }

    vendorReturnSearch: boolean = false;
    vendorReturnNumber: string;
    doVendorReturnSearch(e: any) {
        this.setParam();
        this.vendorReturnSearch = true;
    }
    customFormValidation() {
        return true;
    }
    cancel() {
        super.cancel();
        this.readOnly = false;
    }
    getDataForCancel() {
        return this.createNew(null);
    }
    getData() {
        this.subs_data = this.svc_data.getVendorReturn(this.id).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let busObj: VendorReturnBus = new VendorReturnBus(info.primaryReturn);

                this.setData(busObj);
                this.edit();
            }
        });
      }
    afterDataSet() {
        this.supplierChanged(this.data.supplierId, true);
    }
    seParam: CommonParam;
    includeClosed: boolean = false;
    public includeClosedChanged(e: any) {
        this.setParam();
    }
    setParam() {
        this.seParam = new CommonParam();
        this.seParam.active = !this.includeClosed;
        this.seParam.addParam("SupplierId", this.hasEditForm ? this.editForm.value.supplierId : null);
        this.seParam.addParam("SupplierLocationId", this.hasEditForm ? this.editForm.value.supplierLocationId : null);
        this.seParam.addParam("ReturnDate", this.hasEditForm ? this.editForm.value.returnDate : null);
    }
    vendorReturnSelected(value: any) {
        this.vendorReturnSearch = false;
        if (value != null) {
            this.id = value.VendorReturnId;
            this.getData();
            //this.v.vendorReturnNumber = value.VendorTicketNumber;
            this.svc_data.getVendorReturn(value.VendorReturnId).subscribe(info => {
            })
        }
    }
    saveAll() {
        this.compLoader.cpLoader = true;
        let now: Date = DateFunctions.getDateNow();

        let busObj: VendorReturnBus = new VendorReturnBus(this.data);
        busObj.setFromForm(this.editForm.value);
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        busObj.returnNote ? busObj.returnNote = busObj.returnNote : busObj.returnNote = "";
        // busObj.copyData(this.addtlData, this.pageData);
        busObj.vendorReturnDetails = _.cloneDeep(this.lineItemsComponent.getAll());
        busObj.deletedItems = _.cloneDeep(this.lineItemsComponent.getDeletedItems());
        if (this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.vendorReturnStatusId) && this.editForm.value.vendorReturnStatusId == CommonValues.VendorReturn_StatusReturned) {
            this.printDialog();
            this.compLoader.cpLoader = false;
        }
        else {
            this.svc_data.saveVendorReturn(busObj).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {

                    let retTicket = info.primaryReturn.primaryReturn.returnTicketNumber;
                    this.patchFormreturnTicketNumber(retTicket);
                    this.saveSuccess(retTicket.toString());
                    //this.closed.emit(false);
                }
                else {
                    this.saveError(info.message);
                }
                this.compLoader.cpLoader = false;
            });
        }
    }

    printDialog(data?) {
        this.cnfShow("Any items that are being returned and have not been received will be transferred.  Do you want to continue?", CRUDActions.None, null, "Confirmation");
    }
    confirmDialog(data: ConfirmOutput) {
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            switch (data.action) {
                case CRUDActions.None:
                    handled = true;
                    this.saveVendorReturnWithTransfer();
                    break;
            }
        }
        if (!handled) {
            //this.confirmCustom(data);
        }
    }
    confirmCustom(data: ConfirmOutput) {

    }

    cnfShowSomeGeneralMessage(message: string, title: string = "") {
        this.cnfShow(message, CRUDActions.None, null, title, null);
    }

    saveVendorReturnWithTransfer() {
        let now: Date = DateFunctions.getDateNow();

        let busObj: VendorReturnBus = new VendorReturnBus(this.data);
        busObj.setFromForm(this.editForm.value);
        busObj.setCommon(this.globals.userId, now, this.globals.companyId);
        busObj.returnNote ? busObj.returnNote = busObj.returnNote : busObj.returnNote = "";
        busObj.vendorReturnDetails = _.cloneDeep(this.lineItemsComponent.getAll());
        busObj.deletedItems = _.cloneDeep(this.lineItemsComponent.getDeletedItems());
        this.svc_data.saveVendorReturnWithTransfer(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {

                let retTicket = info.primaryReturn.primaryReturn.returnTicketNumber;
                this.patchFormreturnTicketNumber(retTicket);
                this.saveSuccess(retTicket.toString() + " with Transfer");
                //this.closed.emit(false);
            }
            else {
                this.saveError(info.message);
            }
        });
    }
}
